const API = process.env.REACT_APP_API_ENDPOINT;

const redirectToAuth = () => {
  localStorage.removeItem("token");
  window.location.href = process.env.REACT_APP_RETURN_LEXIA_TOOLS;
};

const apiFetch = async (url, options = {}) => {
  const response = await fetch(url, options);
  if (response.status === 401) {
    redirectToAuth();
    throw new Error("UNAUTHORIZED");
  }
  return response;
};

export const service = {
  loginTools: async (data) => {
    const response = await apiFetch(`${API}api/token-login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Login fallito.");
    }
    return await response.json();
  },

  logout: async (token) => {
    const response = await apiFetch(`${API}api/admin/logout`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Logout fallito.");
    }
    return await response.json();
  },

  getUser: async (token) => {
    const response = await apiFetch(`${API}api/user`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }
    return await response.json();
  },

  getAllAml: async (token, params = {}) => {
    const query = new URLSearchParams();
    if (params.page) query.append("page", params.page);
    if (params.per_page) query.append("per_page", params.per_page);
    const body = {};
    if (params.status) {
      body.status = params.status.split(",").map((s) => s.trim());
    }
    const response = await apiFetch(`${API}api/admin/aml?${query.toString()}`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }
    return await response.json();
  },

  startAML: async (token, data) => {
    const response = await apiFetch(`${API}api/admin/aml/start`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }
    return await response.json();
  },

  editAML: async (token, data, id) => {
    const response = await apiFetch(`${API}api/admin/aml/${id}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }
    return await response.json();
  },

  getSingleAML: async (token, id) => {
    const response = await apiFetch(`${API}api/admin/aml/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }
    return await response.json();
  },

  deleteAml: async (token, id) => {
    const response = await apiFetch(`${API}api/admin/aml/${id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }
    return await response.json();
  },

  SearchAml: async (token, data) => {
    const response = await apiFetch(`${API}api/admin/aml/search`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }
    return await response.json();
  },

  rejectAML: async (token, id, message) => {
    const response = await apiFetch(`${API}api/admin/aml/reject`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ aml_id: String(id), message }),
    });
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }
    return await response.json();
  },

  approveAML: async (token, id) => {
    const response = await apiFetch(`${API}api/admin/aml/approved`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ aml_id: String(id) }),
    });
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }
    return await response.json();
  },

  resendOTP: async (token, id) => {
    const response = await apiFetch(
      `${API}api/admin/aml/${id}/regenerate-otp`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }
    return await response.json();
  },

  restartAML: async (token, id, data) => {
    const response = await apiFetch(`${API}api/admin/aml/${id}/restart`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }
    return await response.json();
  },

  getNatureService: async (token, id) => {
    const response = await apiFetch(`${API}api/admin/aml/${id}/get-nature-service`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }
    return await response.json();
  },

  confirmationRequest: async (token, id, data) => {
    const response = await apiFetch(
      `${API}api/admin/aml/${id}/confirmation-request`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      },
    );
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }
    return await response.json();
  },

  regenerateLink: async (token, id) => {
    const response = await apiFetch(`${API}api/admin/aml/${id}/regenerate-link`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }
    return await response.json();
  },

  restartForUnconfirmed: async (token, id, data) => {
    const response = await apiFetch(`${API}api/admin/aml/${id}/restart-for-unconfirmed`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }
    const text = await response.text();
    try { return text ? JSON.parse(text) : {}; } catch { return {}; }
  },

  archiveAML: async (token, id, data) => {
    const response = await apiFetch(`${API}api/admin/aml/${id}/archive`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore");
    }
    const text = await response.text();
    try { return text ? JSON.parse(text) : {}; } catch { return {}; }
  },

  downloadDocument: async (token, docId) => {
    const response = await apiFetch(
      `${API}api/admin/aml/document/${docId}/download`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    if (!response.ok) {
      const text = await response.text();
      throw new Error(text || "Errore download.");
    }
    return response.blob();
  },
};
